export const languageDefault = {
  en: {
    market_title: 'Metric',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_market: 'Metric',
    button_region: 'Genre',
    region_title: 'Genre',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    market_title: '指标',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '品类',
    region_title: '品类',
    button_market: '指标',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};
